module.exports = __webpack_public_path__ + "img/rongyu-07.a86a1d98.png";